import { render, staticRenderFns } from "./CoursewareRibbonToolbar.vue?vue&type=template&id=62f8ab2d&"
import script from "./CoursewareRibbonToolbar.vue?vue&type=script&lang=js&"
export * from "./CoursewareRibbonToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports